import React from 'react';
import { Nav } from 'react-bootstrap';

export default function Navbar({ setPage }) {
  const pages = ['dashboard','inventory','demand','pricing','agents','orchestration','config'];

  return (
    <Nav variant="tabs" className="justify-content-center mb-4">
      {pages.map((p) => (
        <Nav.Item key={p}>
          <Nav.Link onClick={() => setPage(p)}>
            {p.charAt(0).toUpperCase() + p.slice(1)}
          </Nav.Link>
        </Nav.Item>
      ))}
      <Nav.Item>
        <Nav.Link className="text-danger" onClick={() => { localStorage.removeItem('token'); setPage('login'); }}>
          Logout
        </Nav.Link>
      </Nav.Item>
    </Nav>
  );
}